import type {ButtonProps} from '@chakra-ui/react';
import {Button, forwardRef, useEditableControls} from '@chakra-ui/react';

export const EditableCancelButton = forwardRef<ButtonProps, 'button'>((props, ref) => {
  const {getCancelButtonProps} = useEditableControls();

  return (
    <Button variant={`secondary`} size={`sm`} {...getCancelButtonProps(props, ref)}>
      Cancel
    </Button>
  );
});
